import { computed, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AgentSidePanelStateService {
    readonly currentSessionId = signal<number | null>(null);

    readonly screen = computed<'welcome' | 'chat'>(() => {
        return this.currentSessionId() === null ? 'welcome' : 'chat';
    });

    readonly isWelcomeScreen = computed(() => this.screen() === 'welcome');

    readonly isChatScreen = computed(() => this.screen() === 'chat');
}
